import * as React from 'react';
import {
  VStack as ChakraVStack,
  HStack as ChakraHStack,
  type StackProps,
} from '@chakra-ui/react';

/**
 * Project VStack / HStack.
 *
 * Two NB-parity defaults baked in:
 *
 * - `align: "stretch"` — Chakra v3 defaults to `"center"`; NB / RN
 *   `View` defaulted to `"stretch"`. Without this, every migrated
 *   layout silently collapsed children to natural content width.
 * - `gap: 0` — Chakra v3 stacks default to `gap: "0.5rem"`; NB's
 *   `space` defaulted to `0`.
 *
 * NB's `space` prop maps to Chakra's `gap`. Consumers pass
 * `align="center"` / `gap={3}` explicitly to opt out.
 */

export type { StackProps };

export const VStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ align = 'stretch', gap = 0, ...rest }, ref) => (
    <ChakraVStack ref={ref} align={align} gap={gap} {...rest} />
  )
);
VStack.displayName = 'VStack';

export const HStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ align = 'stretch', gap = 0, ...rest }, ref) => (
    <ChakraHStack ref={ref} align={align} gap={gap} {...rest} />
  )
);
HStack.displayName = 'HStack';
